import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';

import { DonutChartComponent } from '../../chart/donut-chart.component';
import { CoralCashbackBaseComponent } from '../coral-cashback-base.component';
import { AccountMenuTileComponent } from './tile.component';

@Component({
    imports: [CommonModule, AccountMenuTileComponent, DonutChartComponent, TrustAsHtmlPipe],
    selector: 'vn-am-coral-cashback-tile',
    templateUrl: 'cashback-tile.html',
})
export class CoralCashbackTileComponent extends CoralCashbackBaseComponent {
    constructor() {
        super();
    }
}
